<template>
  <div
    class="bottom-active-order-widget flex-column active"
    v-if="!isOrderDelivered && !cartQuantity"
  >
    <div class="flex-row justify-content-between width100">
      <div>
        <div v-if="timeStatusValue?.length" class="active-order-card-time mb12">
          <span
            class="fs-11 fw-800 active-order-card-on-time"
            :class="[timeStatusTagBgColorClass, timeStatusTagFontColorClass]"
            ><i v-if="showBoltIcon" class="hkfi-bolt-icon fs-12 mr3" />{{
              timeStatusValue
            }}</span
          >
          <span class="active-order-card-arrive-text fs-12">Arriving in</span>
          <span class="time fs-14 fw-800">{{ etaTime }} min</span>
        </div>
        <div class="active-order-card-desc fs-16 fw-700">
          {{ timeLineText }}
        </div>
      </div>
      <div class="flex-column align-items-flex-end">
        <i class="hkfi-expand fs-16" @click="sendToTrackingPage" />
        <!-- <div
          class="active-order-card-image"
          v-if="!isOrderDelivered && getOrderStatusImgUrl?.length"
        >
          <img :src="getOrderStatusImgUrl" class="width100" />
        </div> -->
      </div>
    </div>
    <progress-bar
      v-if="isOrderStatusBeforeDelivery"
      :percent="progressBarPercent"
    ></progress-bar>
    <div v-else>{{ bottomText }}</div>
  </div>
</template>

<script>
import get from "lodash/get";
import { keyMapsAction, keyMapsGetter } from "../helpers/storeKeys";
import { clientPlatform, staticImgBaseUrl } from "../config/apiEndpoints";
import ProgressBar from "./reusableComponents/ProgressBar.vue";
import Observer from "./Observer.vue";
import {
  OrderStatusTimelineTextForDelivery,
  OrderStatusHelpBottomTextForDeliveryKey,
  BottomWidgetOrderStatusImgIconKey,
  TimeStatusTagBgColorClass,
  TimeStatusTagFontColorClass,
  ShowBoltIcon,
} from "../helpers/OrderStatusConstants";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";

export default {
  name: "ActiveOrderBottomWidget",
  components: {
    ProgressBar,
    Observer,
  },
  props: {
    dataResults: { required: false, default: "" },
    sourcePage: { required: false, default: "" },
    activateOrderCardClick: { required: false, default: false },
    index: { required: false, default: 0 },
    dataProps: { required: true, default: {} },
  },
  data() {
    return {
      staticImgBaseUrl,
      clientPlatform,
      animationInstance: {},
      modulePropsData: {},
      inView: false,
      limit: 3,
      ratingTags: {},
      moduleProps: {},
      startPolling: false,
    };
  },
  mounted() {
    this.moduleProps = this.dataProps;
  },
  unmounted() {},
  methods: {
    cardObserved() {
      this.startPolling = true;
      setTimeout(() => {
        this.pollData();
      }, 60);
    },
    cardUnobserved() {
      this.startPolling = false;
    },
    pollData() {
      if (this.startPolling) {
        setTimeout(() => {
          this.$store.dispatch(keyMapsAction.POST_ORDER_TRACKER_API, {
            orderId: this.order?.id,
          });
          this.pollData();
        }, 60000);
      }
    },
    sendToTrackingPage() {
      LocalStorageFunc.setOrderId(this.order?.id);
      LocalStorageFunc.setOrderSummary(this.order);
      setTimeout(() => {
        Utility.sendToOrderTracking();
      }, 10);
    },
  },
  computed: {
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    currentOrderState() {
      return this.isCurrentOrder && this.postOrderTrackerResponse?.orderStatus
        ? this.postOrderTrackerResponse?.orderStatusCode
        : this.order?.orderCurrentState;
    },
    progressBarPercent() {
      return this.isCurrentOrder && this.postOrderTrackerResponse?.orderStatus
        ? this.eta.progress
        : this.currentOrderState * 10;
    },
    timeLineText() {
      return this.isCurrentOrder && this.postOrderTrackerResponse?.orderStatus
        ? this.orderTrackingMessages?.statusMessage
        : OrderStatusTimelineTextForDelivery[this.currentOrderState];
    },
    bottomText() {
      return OrderStatusHelpBottomTextForDeliveryKey[this.currentOrderState];
    },
    postOrderTrackerResponse() {
      return this.$store.state.OrderTracking?.postOrderTrackerResponse;
    },
    eta() {
      return this.postOrderTrackerResponse?.etaWidget?.eta;
    },
    etaTime() {
      return this.eta?.eta;
    },
    timeStatusValue() {
      return this.eta?.timeStatusValue;
    },
    orderTrackingMessages() {
      return this.postOrderTrackerResponse?.etaWidget?.orderTrackingMessages;
    },
    isCurrentOrder() {
      return (
        this.order?.id == this.$store.state.OrderTracking?.currentTrackerOrderId
      );
    },
    isOrderDelivered() {
      return this.currentOrderState == 9;
    },
    isOrderOnGate() {
      return this.currentOrderState == 10;
    },
    isOrderStatusBeforeDelivery() {
      return !this.isOrderDelivered && !this.isOrderOnGate;
    },
    order() {
      return this.$store.getters[keyMapsGetter.GET_CURRENT_TRACKED_ORDER][0];
    },
    getOrderStatusImgUrl() {
      return get(
        this.dataProps,
        BottomWidgetOrderStatusImgIconKey[this.currentOrderState],
        "",
      );
    },
    timeStatusTagBgColorClass() {
      return TimeStatusTagBgColorClass[this.eta?.timeStatus];
    },
    timeStatusTagFontColorClass() {
      return TimeStatusTagFontColorClass[this.eta?.timeStatus];
    },
    showBoltIcon() {
      return ShowBoltIcon[this.eta?.timeStatus];
    },
  },
};
</script>
